module.exports = __webpack_public_path__ + "img/logo2.0faabdb2.png";